// Header is no longer fixed, so padding is not needed

// Mobile Menu Toggle
function toggleMobileMenu() {
    const nav = document.getElementById('mainNav');
    nav.classList.toggle('active');
    
    // Close search box if open when opening menu
    const searchBox = document.getElementById('mobile-search-box');
    if (searchBox && searchBox.classList.contains('active')) {
        searchBox.classList.remove('active');
    }
    
}

// Mobile Search Toggle
function toggleMobileSearch() {
    const searchBox = document.getElementById('mobile-search-box');
    if (searchBox) {
        searchBox.classList.toggle('active');
        
        // Focus on search input when opened
        if (searchBox.classList.contains('active')) {
            const searchInput = searchBox.querySelector('.search-input');
            if (searchInput) {
                setTimeout(() => searchInput.focus(), 100);
            }
            // Close menu if open
            const nav = document.getElementById('mainNav');
            if (nav && nav.classList.contains('active')) {
                nav.classList.remove('active');
            }
        }
    }
}

// Close mobile menu when clicking outside
document.addEventListener('click', function(event) {
    const nav = document.getElementById('mainNav');
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    
    if (nav && menuToggle && !nav.contains(event.target) && !menuToggle.contains(event.target)) {
        nav.classList.remove('active');
    }
    
    // Close search box when clicking outside
    const searchBox = document.getElementById('mobile-search-box');
    const searchToggle = document.querySelector('.mobile-search-toggle');
    const searchClose = document.querySelector('.mobile-search-close');
    
    if (searchBox && searchToggle && !searchBox.contains(event.target) && 
        !searchToggle.contains(event.target) && !searchClose?.contains(event.target)) {
        if (window.innerWidth <= 768) {
            searchBox.classList.remove('active');
        }
    }
});

// Close mobile menu on window resize
window.addEventListener('resize', function() {
    const nav = document.getElementById('mainNav');
    const searchBox = document.getElementById('mobile-search-box');
    
    
    if (window.innerWidth > 768) {
        if (nav) {
            nav.classList.remove('active');
            // Close all mobile submenus
            document.querySelectorAll('.header-nav .menu-item.active').forEach(item => {
                item.classList.remove('active');
            });
        }
        if (searchBox) searchBox.classList.remove('active');
    }
});

// Mega Menu Functionality
document.addEventListener('DOMContentLoaded', function() {
    // Fix mega menu positioning
    function positionMegaMenu() {
        if (window.innerWidth > 768) {
            document.querySelectorAll('.mega-menu').forEach(megaMenu => {
                const headerNav = document.querySelector('.header-nav');
                if (headerNav) {
                    const headerNavRect = headerNav.getBoundingClientRect();
                    
                    // Position mega menu below header nav, full width
                    megaMenu.style.position = 'fixed';
                    megaMenu.style.top = (headerNavRect.bottom) + 'px';
                    megaMenu.style.left = '0';
                    megaMenu.style.right = '0';
                    megaMenu.style.width = '100%';
                    megaMenu.style.maxWidth = '100%';
                    megaMenu.style.marginLeft = '0';
                    
                    if (!megaMenu.classList.contains('active')) {
                        megaMenu.style.transform = 'translateY(-10px)';
                    }
                }
            });
        }
    }
    
    positionMegaMenu();
    window.addEventListener('resize', positionMegaMenu);
    window.addEventListener('scroll', positionMegaMenu);
    
    // Desktop: Show mega menu on hover
    if (window.innerWidth > 768) {
        document.querySelectorAll('.header-nav .menu-item.has-submenu').forEach((menuItem, index) => {
            const menuIndex = menuItem.getAttribute('data-menu-index');
            const megaMenu = document.querySelector(`.mega-menu[data-menu-parent="${menuIndex}"]`);
            
            if (megaMenu) {
                menuItem.addEventListener('mouseenter', function() {
                    // Close all other mega menus
                    document.querySelectorAll('.mega-menu').forEach(menu => {
                        menu.classList.remove('active');
                    });
                    // Position this mega menu
                    positionMegaMenu();
                    // Show this mega menu
                    megaMenu.classList.add('active');
                    megaMenu.style.transform = 'translateY(0)';
                });
                
                menuItem.addEventListener('mouseleave', function(e) {
                    // Only hide if not moving to mega menu
                    if (!megaMenu.contains(e.relatedTarget)) {
                        megaMenu.classList.remove('active');
                        megaMenu.style.transform = 'translateY(-10px)';
                    }
                });
                
                megaMenu.addEventListener('mouseenter', function() {
                    this.style.transform = 'translateY(0)';
                });
                
                megaMenu.addEventListener('mouseleave', function() {
                    this.classList.remove('active');
                    this.style.transform = 'translateY(-10px)';
                });
            }
        });
    }
    
    // Create mobile mega menus on load/resize
    function createMobileMegaMenus() {
        if (window.innerWidth <= 768) {
            document.querySelectorAll('.header-nav .menu-item.has-submenu').forEach(menuItem => {
                const menuIndex = menuItem.getAttribute('data-menu-index');
                const megaMenu = document.querySelector(`.mega-menu[data-menu-parent="${menuIndex}"]`);
                
                if (megaMenu && !menuItem.querySelector('.mobile-mega-menu')) {
                    const mobileMegaMenu = megaMenu.cloneNode(true);
                    mobileMegaMenu.classList.add('mobile-mega-menu');
                    mobileMegaMenu.classList.remove('mega-menu');
                    menuItem.appendChild(mobileMegaMenu);
                }
            });
        } else {
            // Remove mobile mega menus on desktop
            document.querySelectorAll('.mobile-mega-menu').forEach(mobileMega => {
                mobileMega.remove();
            });
        }
    }
    
    createMobileMegaMenus();
    window.addEventListener('resize', createMobileMegaMenus);
    
    // Mobile: Handle menu item clicks to toggle submenus
    document.querySelectorAll('.header-nav .menu-item.has-submenu').forEach(menuItem => {
        const menuIndex = menuItem.getAttribute('data-menu-index');
        const megaMenu = document.querySelector(`.mega-menu[data-menu-parent="${menuIndex}"]`);
        const menuLink = menuItem.querySelector('.menu-link');
        
        if (menuLink && megaMenu) {
            menuLink.addEventListener('click', function(e) {
                // Only prevent default on mobile
                if (window.innerWidth <= 768) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Get the mobile mega menu (should be created by createMobileMegaMenus)
                    const mobileMegaMenu = menuItem.querySelector('.mobile-mega-menu');
                    const targetMegaMenu = mobileMegaMenu || megaMenu;
                    
                    // Check if this menu item is already active
                    const isActive = menuItem.classList.contains('active');
                    
                    // Close all other mega menus and menu items first
                    document.querySelectorAll('.header-nav .menu-item.active').forEach(item => {
                        if (item !== menuItem) {
                            item.classList.remove('active');
                            const otherMobileMega = item.querySelector('.mobile-mega-menu');
                            if (otherMobileMega) otherMobileMega.classList.remove('active');
                        }
                    });
                    document.querySelectorAll('.mega-menu.active, .mobile-mega-menu.active').forEach(menu => {
                        if (menu !== targetMegaMenu && menu !== megaMenu) {
                            menu.classList.remove('active');
                        }
                    });
                    
                    // Toggle this menu item and its mega menu
                    if (isActive) {
                        // If already active, close it
                        menuItem.classList.remove('active');
                        targetMegaMenu.classList.remove('active');
                    } else {
                        // If not active, open it
                        menuItem.classList.add('active');
                        targetMegaMenu.classList.add('active');
                    }
                }
            });
        }
    });
    
    // Close mega menus when clicking outside (desktop)
    document.addEventListener('click', function(e) {
        if (window.innerWidth > 768) {
            const menuItem = e.target.closest('.menu-item.has-submenu');
            const megaMenu = e.target.closest('.mega-menu');
            
            // If clicking outside any menu item or mega menu
            if (!menuItem && !megaMenu) {
                document.querySelectorAll('.mega-menu').forEach(menu => {
                    menu.classList.remove('active');
                });
            }
        }
    });
});

// Product Card Quantity Selector
document.addEventListener('DOMContentLoaded', function() {
    // Make product cards clickable (navigate to product page)
    document.querySelectorAll('.product-card[data-product-url]').forEach(card => {
        card.addEventListener('click', function(e) {
            // Don't navigate if clicking on interactive elements
            const interactiveElements = [
                'button',
                'a',
                'input',
                'select',
                'textarea',
                '.product-card-actions',
                '.product-bookmark',
                '.quantity-selector-small',
                '.qty-btn-small',
                '.qty-input-small',
                '.product-card-form',
                '.btn-add-to-cart-card'
            ];
            
            // Check if the click target or its parent is an interactive element
            let target = e.target;
            let isInteractive = false;
            
            for (let i = 0; i < 5; i++) { // Check up to 5 levels up
                if (!target) break;
                
                // Check if target matches any interactive selector
                for (const selector of interactiveElements) {
                    if (target.matches && target.matches(selector)) {
                        isInteractive = true;
                        break;
                    }
                    // Also check if it's inside an element with data-stop-propagation
                    if (target.closest && target.closest('[data-stop-propagation]')) {
                        isInteractive = true;
                        break;
                    }
                }
                
                if (isInteractive) break;
                target = target.parentElement;
            }
            
            // Only navigate if not clicking on interactive elements
            if (!isInteractive) {
                const productUrl = this.getAttribute('data-product-url');
                if (productUrl) {
                    window.location.href = productUrl;
                }
            }
        });
    });
    
    // Prevent card click when clicking on interactive elements
    document.querySelectorAll('[data-stop-propagation]').forEach(element => {
        element.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    });
    
    // Handle quantity increment/decrement on product cards
    document.querySelectorAll('.qty-btn-small').forEach(button => {
        button.addEventListener('click', function(e) {
            e.stopPropagation(); // Prevent card navigation
            const quantitySelector = this.closest('.quantity-selector-small');
            if (!quantitySelector) return;
            
            const input = quantitySelector.querySelector('.qty-input-small');
            const productCard = quantitySelector.closest('.product-card');
            const quantityInput = productCard?.querySelector('.product-quantity-input');
            
            if (!input) return;
            
            let currentValue = parseInt(input.value) || 1;
            
            if (this.classList.contains('qty-plus')) {
                currentValue += 1;
            } else if (this.classList.contains('qty-minus')) {
                currentValue = Math.max(1, currentValue - 1);
            }
            
            input.value = currentValue;
            if (quantityInput) {
                quantityInput.value = currentValue;
            }
            
            // Update disabled state of minus button
            const minusBtn = quantitySelector.querySelector('.qty-minus');
            if (minusBtn) {
                minusBtn.disabled = currentValue <= 1;
            }
        });
    });
    
    // Handle direct input changes on product cards
    document.querySelectorAll('.qty-input-small').forEach(input => {
        input.addEventListener('click', function(e) {
            e.stopPropagation(); // Prevent card navigation
        });
        
        input.addEventListener('change', function(e) {
            e.stopPropagation(); // Prevent card navigation
            let value = parseInt(this.value) || 1;
            if (value < 1) value = 1;
            this.value = value;
            
            const productCard = this.closest('.product-card');
            const quantityInput = productCard?.querySelector('.product-quantity-input');
            
            if (quantityInput) {
                quantityInput.value = value;
            }
            
            // Update disabled state of minus button
            const quantitySelector = this.closest('.quantity-selector-small');
            const minusBtn = quantitySelector?.querySelector('.qty-minus');
            if (minusBtn) {
                minusBtn.disabled = value <= 1;
            }
        });
        
        // Initialize disabled state
        const quantitySelector = input.closest('.quantity-selector-small');
        const minusBtn = quantitySelector?.querySelector('.qty-minus');
        if (minusBtn && parseInt(input.value) <= 1) {
            minusBtn.disabled = true;
        }
    });
    
    // Handle add to cart form submission on product cards
    document.querySelectorAll('.product-card-form').forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent card navigation
            
            const productCard = this.closest('.product-card');
            const quantityInput = this.querySelector('.product-quantity-input');
            const input = productCard?.querySelector('.qty-input-small');
            const quantity = quantityInput ? parseInt(quantityInput.value) : (input ? parseInt(input.value) : 1);
            
            // Update the quantity input in the form
            const formQuantityInput = this.querySelector('input[name="quantity"]');
            if (formQuantityInput) {
                formQuantityInput.value = quantity;
            }
            
            // Submit the form
            const formData = new FormData(this);
            const submitBtn = this.querySelector('.btn-add-to-cart-card');
            
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Adding...';
            }
            
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                // Success - show notification or update cart count
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Added!';
                    setTimeout(() => {
                        submitBtn.textContent = 'Add to Cart';
                    }, 2000);
                }
                // Reload to update cart count in header
                window.location.reload();
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Add to Cart';
                }
                alert('There was an error adding the product to your cart. Please try again.');
            });
        });
    });
    
    // Prevent bookmark button from navigating
    document.querySelectorAll('.product-bookmark').forEach(button => {
        button.addEventListener('click', function(e) {
            e.stopPropagation(); // Prevent card navigation
            // Add bookmark functionality here if needed
        });
    });
    
    // Prevent product title link from double navigation (since card is also clickable)
    document.querySelectorAll('.product-title-link').forEach(link => {
        link.addEventListener('click', function(e) {
            // Let the link handle navigation, but stop card click
            e.stopPropagation();
        });
    });
    
    // Fix product title wrapping - add break opportunities and prevent awkward breaks
    document.querySelectorAll('.product-title span').forEach(titleSpan => {
        let titleText = titleSpan.textContent;
        
        // Add space after "&" to allow breaking after ampersand
        if (titleText.includes('&')) {
            titleText = titleText.replace(/&(?!\s|nbsp;|amp;|#)/g, '& ');
        }
        
        // Add non-breaking spaces for measurements like "3.5 x 45" to keep them together
        // This prevents breaking between numbers and "x" in dimensions
        titleText = titleText.replace(/(\d+\.?\d*)\s+x\s+(\d+)/g, '$1\u00A0x\u00A0$2');
        
        // Update the title if we made changes
        if (titleText !== titleSpan.textContent) {
            titleSpan.textContent = titleText;
        }
    });
});

// Handle scroll product add to cart forms
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.scroll-add-form').forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const formData = new FormData(this);
            const submitBtn = this.querySelector('.btn-scroll-cart');
            
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Adding...';
            }
            
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Added!';
                    setTimeout(() => {
                        submitBtn.textContent = 'ADD TO CART';
                    }, 2000);
                }
                window.location.reload();
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'ADD TO CART';
                }
                alert('There was an error adding the product to your cart. Please try again.');
            });
        });
    });
});

// Product description: collapsed on mobile, expanded on desktop (details element)
(function () {
    function syncProductDescriptionAccordion() {
        var el = document.getElementById('ProductDescriptionAccordion');
        if (!el) return;
        el.open = window.innerWidth > 768;
    }
    document.addEventListener('DOMContentLoaded', syncProductDescriptionAccordion);
    window.addEventListener('resize', syncProductDescriptionAccordion);
})();

